// extracted by mini-css-extract-plugin
module.exports = {"styledSubmitButton":"wy2cqZQe","form":"PCBrfthR","loaderWrapper":"BmBykfe8","isMessagePending":"KJRt6HwX","spin":"h8aEkj8g","modesSwitcher":"loVkrwZN","footer":"_JxbT9Im"};